import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5a44018"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "transactionsLoading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"width":"50px","background":"transparent","display":"block","shape-rendering":"auto"},
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: "#fff",
    "stroke-width": "10",
    r: "35",
    "stroke-dasharray": "164.93361431346415 56.97787143782138"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      repeatCount: "indefinite",
      dur: "1s",
      values: "0 50 50;360 50 50",
      keyTimes: "0;1"
    })
  ])
], -1))
const _hoisted_3 = { class: "chooseScreenOptions" }
const _hoisted_4 = { class: "flex items-stretch stakeSection" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_ConfirmAlert = _resolveComponent("ConfirmAlert")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.transactions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h1", null, _toDisplayString(_ctx.handleMovingMessage()), 1),
          _createVNode(_component_fa, {
            icon: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.transactions=false)),
            class: "txClose"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showScreen = 'Wallet')),
        style: _normalizeStyle(_ctx.showScreen === 'Wallet' ? {background: '#f1f1f1',color: '#1e1e1e'} : {background: '#1e1e1e',color: '#f1f1f1'})
      }, "Wallet (" + _toDisplayString(_ctx.desiredWalletNFTs.length) + ")", 5),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showScreen = 'Vault')),
        style: _normalizeStyle(_ctx.showScreen !== 'Wallet' ? {background: '#f1f1f1',color: '#1e1e1e'} : {background: '#1e1e1e',color: '#f1f1f1'})
      }, "Vault (" + _toDisplayString(_ctx.desiredVaultNFTs.length) + ")", 5)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.showScreen === 'Wallet')
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Wallet",
            class: "flex-1",
            nfts: _ctx.desiredWalletNFTs,
            isStaked: _ctx.farmerState,
            loading: _ctx.loading,
            available: _ctx.availableA,
            farm: _ctx.farm,
            farmAcc: _ctx.farmAcc,
            farmer: _ctx.farmer,
            farmerAcc: _ctx.farmerAcc,
            onSelected: _ctx.handleWalletSelected,
            onStake: _ctx.handleStake,
            onUnstake: _ctx.handleUnstake,
            onClaim: _ctx.handleClaim,
            onRefreshFarmer: _ctx.handleRefreshFarmer
          }, null, 8, ["nfts", "isStaked", "loading", "available", "farm", "farmAcc", "farmer", "farmerAcc", "onSelected", "onStake", "onUnstake", "onClaim", "onRefreshFarmer"]))
        : _createCommentVNode("", true),
      (_ctx.showScreen === 'Vault')
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 1,
            title: "Vault",
            class: "flex-1",
            nfts: _ctx.desiredVaultNFTs,
            isStaked: _ctx.farmerState,
            loading: _ctx.loading,
            available: _ctx.availableA,
            farm: _ctx.farm,
            farmAcc: _ctx.farmAcc,
            farmer: _ctx.farmer,
            farmerAcc: _ctx.farmerAcc,
            onSelected: _ctx.handleVaultSelected,
            onStake: _ctx.handleStake,
            onUnstake: _ctx.handleUnstake,
            onClaim: _ctx.handleClaim,
            onRefreshFarmer: _ctx.handleRefreshFarmer
          }, null, 8, ["nfts", "isStaked", "loading", "available", "farm", "farmAcc", "farmer", "farmerAcc", "onSelected", "onStake", "onUnstake", "onClaim", "onRefreshFarmer"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.claimConfirm === true)
      ? (_openBlock(), _createBlock(_component_ConfirmAlert, {
          key: 1,
          message: `You have unclaimed rewards!`,
          submessage: `Please claim them before unstaking or you will lose those rewards permanently.`,
          no: () => {_ctx.endStaking();_ctx.claimConfirm = false}
        }, null, 8, ["submessage", "no"]))
      : _createCommentVNode("", true),
    (_ctx.showAlert === true)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          message: 'Claiming',
          type: 'pending'
        }))
      : _createCommentVNode("", true),
    (_ctx.showError === true)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 3,
          message: 'Error!',
          type: 'error'
        }))
      : _createCommentVNode("", true),
    (_ctx.showSuccess === true)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 4,
          message: 'Success!',
          type: 'success'
        }))
      : _createCommentVNode("", true)
  ], 64))
}